import NotFound from "../views/NotFoundPage.vue";

import Login from "../views/Authentication/Login";

import Signup from "../views/Authentication/Signup";
import Invite from "../views/Authentication/Invite";

import Forgot from "../views/Authentication/Forgot";

import Dashboard from "../views/Dashboard";

import Services from "../views/Services";

import Profile from "../views/Profile";

import Documents from "../views/Documents/Page";
import DocumentsPublic from "../views/Documents/Public";
import DocumentsTeam from "../views/Documents/Team";
import DocumentsDrafts from "../views/Documents/Drafts";
import DocumentsRequests from "../views/Documents/Requests";
import Document from "../views/Documents/Document";

import Templates from "../views/Templates/Page";
import TemplatesPublic from "../views/Templates/Public";
import TemplatesTeam from "../views/Templates/Team";
import TemplatesDrafts from "../views/Templates/Drafts";
import Template from "../views/Templates/Template";
import TemplateDocument from "../views/Templates/Document";

import Team from "../views/Team/Page";
import TeamUsers from "../views/Team/Users";
import TeamInvites from "../views/Team/Invites";
import TeamApplications from "../views/Team/Applications";
import TeamPayments from "../views/Team/Payments";

import Settings from "../views/Settings";


import Full from "../views/Full";

const routes = [
  {
    path: "/",
    redirect: "/dashboard",
    name: "Home",
    component: Full,
    children: [
      {
        path: "/dashboard",
        name: "Overview",
        component: Dashboard,
        meta: {
          requiresAuth: true,
          public: false
        }
      },
      {
        path: "/services",
        name: "Services",
        component: Services,
        meta: {
          requiresAuth: true,
          public: false
        }
      },
      {
        path: '/documents',
        name: "Documents",
        component: Documents,
        redirect: '/documents/public',
        children: [
          {
            path: "public",
            name: "Documents.Public",
            component: DocumentsPublic,
            meta: {
              requiresAuth: true,
              public: false
            }
          },
          {
            path: "team",
            name: "Documents.Team",
            component: DocumentsTeam,
            meta: {
              requiresAuth: true,
              public: false
            }
          },
          {
            path: "drafts",
            name: "Documents.Drafts",
            component: DocumentsDrafts,
            meta: {
              requiresAuth: true,
              public: false
            }
          },
          {
            path: "requests",
            name: "Documents.Requests",
            component: DocumentsRequests,
            meta: {
              requiresAuth: true,
              public: false
            }
          }
        ]
      },
      {
        path: '/templates',
        name: "Templates",
        component: Templates,
        redirect: '/templates/public',
        children: [
          {
            path: "public",
            name: "Templates.Public",
            component: TemplatesPublic,
            meta: {
              requiresAuth: true,
              public: false
            }
          },
          {
            path: "team",
            name: "Templates.Team",
            component: TemplatesTeam,
            meta: {
              requiresAuth: true,
              public: false
            }
          },
          {
            path: "drafts",
            name: "Templates.Drafts",
            component: TemplatesDrafts,
            meta: {
              requiresAuth: true,
              public: false
            }
          } 
        ]
      },
      {
        name: "Team",
        path: "/team",
        component: Team,
        redirect: "/team/list",
        children: [
          {
            path: "list",
            name: "TeamUsers",
            component: TeamUsers,
            meta: {
              requiresAuth: true,
              public: false
            }
          },
          {
            path: "invites",
            name: "TeamInvites",
            component: TeamInvites,
            meta: {
              requiresAuth: true,
              public: false
            }
          },
          {
            path: "applications",
            name: "TeamApplications",
            component: TeamApplications,
            meta: {
              requiresAuth: true,
              public: false
            }
          },
          {
            path: "payments",
            name: "TeamPayments",
            component: TeamPayments,
            meta: {
              requiresAuth: true,
              public: false
            }
          }
        ]
      },
      {
        path: '/profile/:profileId',
        name: "Profile",
        component: Profile,
        meta: {
          requiresAuth: true,
          public: false
        },
        props: route => ({ profileId: Number(route.params.profileId) })
      },
      {
        path: "/document/:dclIdentity",
        name: "Document",
        component: Document,
        meta: {
          requiresAuth: false,
          public: true
        },
        props: route => ({ dclIdentity: route.params.dclIdentity })
      },
      {
        path: "/template/:dclIdentity",
        name: "Template",
        component: Template,
        meta: {
          requiresAuth: false,
          public: true
        },
        props: route => ({ dclIdentity: route.params.dclIdentity })
      },      
      {
        path: "/template/document/:documentId",
        name: "Template.Document",
        component: TemplateDocument,
        meta: {
          requiresAuth: true,
          public: false
        },
        props: route => ({ documentId: Number(route.params.documentId) })
      },
      {
        path: "/settings",
        name: "Settings",
        component: Settings,
        meta: {
          requiresAuth: true,
          public: false
        }
      },
      {
        path: "/login",
        name: "Login",
        component: Login,
        meta: {
          requiresAuth: false,
          public: false
        },
        props: route => ({ redirect: route.params.redirect })
      },
      {
        path: "/signup",
        name: "Signup",
        component: Signup,
        meta: {
          requiresAuth: false,
          public: false
        }
      },
      {
        path: "/Invite",
        name: "Invite",
        component: Invite,
        meta: {
          requiresAuth: false,
          public: false
        }
      },
      {
        path: "/forgot",
        name: "Forgot",
        component: Forgot,
        meta: {
          requiresAuth: false,
          public: false
        }
      }
    ]
  },
  { path: "*", component: NotFound }
];

export default routes;
